/**
 * =============================================================================
 * Berater-Gate (Issue #1, Paket D-UI)
 * =============================================================================
 * Reine Frontend-Entscheidung, ob der Sicherheitsberater-Einstieg (CTA im
 * Banner, /berater-Route, Widgets) gerendert wird. Der serverseitige Gate
 * (403 auf der Berater-API) wird parallel implementiert – dieses Gate steuert
 * nur die Sichtbarkeit im Shop-Frontend.
 *
 * Regel: advisor_enabled === false blendet den Berater aus. In allen anderen
 * Fällen gilt der bisherige Zustand (Berater nur im Demo-Modus sichtbar).
 */

export function isAdvisorEntryEnabled(tenant) {
  const settings = tenant?.settings || {};
  if (settings.demo_mode !== true) return false;
  // Identische Semantik wie functions/api/_lib/advisor-gate.js:
  // 'false' (String, wie in settings_json gespeichert) ODER false (Boolean) blendet aus.
  if (settings.advisor_enabled === false) return false;
  if (settings.advisor_enabled === 'false') return false;
  return true;
}
